import React from "react";
import CollapsibleSection from "./CollapsibleSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebook, faYoutube } from "@fortawesome/free-brands-svg-icons";

const SocialMediaPanel = ({
    isOpen,
    onToggle,
    formData,
    setFormData,
    normalizeURL
}) => {
    return (
        <CollapsibleSection
            title="🔗 Social Media Links"
            isOpen={isOpen}
            onToggle={onToggle}
        >
            <div className="form-section">
                <small className="note">
                    If provided, these will be displayed on your dealer profile
                </small>
                <br />

                <label>
                    <FontAwesomeIcon className="socialMediaIcon" icon={faInstagram} />
                    <span className="socialMediaText">Instagram</span>
                </label>
                <input
                    type="url"
                    placeholder="https://instagram.com/yourhandle"
                    value={formData.instagram || ""}
                    onChange={(e) =>
                        setFormData({ ...formData, instagram: e.target.value })
                    }
                    onBlur={(e) =>
                        setFormData({
                            ...formData,
                            instagram: normalizeURL(e.target.value),
                        })
                    }
                />

                <div className="space-div" />
                <label>
                    <FontAwesomeIcon className="socialMediaIcon" icon={faFacebook} />
                    <span className="socialMediaText">Facebook</span>
                </label>
                <input
                    type="url"
                    placeholder="https://facebook.com/yourpage"
                    value={formData.facebook || ""}
                    onChange={(e) =>
                        setFormData({ ...formData, facebook: e.target.value })
                    }
                    onBlur={(e) =>
                        setFormData({
                            ...formData,
                            facebook: normalizeURL(e.target.value),
                        })
                    }
                />

                <div className="space-div" />
                <label>
                    <FontAwesomeIcon className="socialMediaIcon" icon={faYoutube} />
                    <span className="socialMediaText">YouTube</span>
                </label>
                <input
                    type="url"
                    placeholder="https://youtube.com/channel/..."
                    value={formData.youtube || ""}
                    onChange={(e) =>
                        setFormData({ ...formData, youtube: e.target.value })
                    }
                    onBlur={(e) =>
                        setFormData({
                            ...formData,
                            youtube: normalizeURL(e.target.value),
                        })
                    }
                />
            </div>
        </CollapsibleSection>
    );
};

export default SocialMediaPanel;